import { RootState } from "@/redux/store";

// Base selectors for Redux state
export const subscriptionAssignmentStateSelector = (state: RootState) => state.subscriptionAssignment;
export const assignmentsSelector = (state: RootState) => state.subscriptionAssignment.assignments;
export const isLoadingSelector = (state: RootState) => state.subscriptionAssignment.isLoading;
export const errorSelector = (state: RootState) => state.subscriptionAssignment.error;
export const hasShownWelcomeModalSelector = (state: RootState) => state.subscriptionAssignment.hasShownWelcomeModal;
export const showPlanSelectionModalSelector = (state: RootState) => state.subscriptionAssignment.showPlanSelectionModal;
export const hasEverLoadedPaymentMethodsSelector = (state: RootState) => state.subscriptionAssignment.hasEverLoadedPaymentMethods;
export const preSelectedPlanIdSelector = (state: RootState) => state.subscriptionAssignment.preSelectedPlanId;
